const getters={
  token:state=>state.user.token,
  username:state=>state.user.username,
  head:state=>state.user.head,
  buyPackageShow:state=>state.user.buyPackageShow,
  packageList:state=>state.user.packageList,
  packageBuy:state=>state.user.packageBuy,
  pageTitle:state=>state.app.pageTitle,
  breadcrumb:state=>state.app.breadcrumb,
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js